import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-legal-information',
  templateUrl: './legal-information.component.html',
  styleUrls: ['./legal-information.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LegalInformationComponent {
  readonly openSources: {
    name: string;
    url: string;
  }[] = [
    {
      name: 'Angular',
      url: 'https://angular.dev/license',
    },
    {
      name: 'Node.js',
      url: 'https://github.com/nodejs/node/blob/master/LICENSE',
    },
    {
      name: 'NgRx',
      url: 'https://ngrx.io/license',
    },
    {
      name: 'rxjs',
      url: 'https://github.com/ReactiveX/rxjs/blob/master/LICENSE.txt',
    },
    {
      name: 'TypeScript',
      url: 'https://github.com/microsoft/TypeScript/blob/main/LICENSE.txt',
    },
    {
      name: 'Gulp',
      url: 'https://github.com/gulpjs/gulp/blob/master/LICENSE',
    },
    {
      name: 'Jasmine',
      url: 'https://github.com/jasmine/jasmine/blob/main/LICENSE',
    },
    {
      name: 'Jenkins',
      url: 'https://www.jenkins.io/license/',
    },
    {
      name: 'Git',
      url: 'https://git-scm.com/about/free-and-open-source',
    },
    {
      name: 'Karma',
      url: 'https://github.com/karma-runner/karma/blob/master/LICENSE',
    },
    {
      name: 'lodash',
      url: 'https://github.com/lodash/lodash/blob/master/LICENSE',
    },
  ];

  constructor() {}
}
